<div class="home-card widget-invite">
    <ng-container *ngIf="!isLoading; else skeleton">
        <ng-container *ngIf="selectedCommunity">
            <div class="title">
                <h3 *ngIf="communities.length === 1; else dropdown">{{ selectedCommunity.name }}</h3>

                <ng-template #dropdown>
                    <div class="dropdown">
                        <button class="btn btn-light dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
                            <span>{{ selectedCommunity.name }}</span>
                        </button>
                        <div class="dropdown-menu">
                            <a class="dropdown-item" (click)="selectCommunity(community)" *ngFor="let community of communities">{{
                                community.name
                            }}</a>
                        </div>
                    </div>
                </ng-template>
            </div>

            <div class="invite-main">
                <div class="member-count-container">
                    <span class="bold-info member-count">{{ selectedCommunity.memberCount }}</span>
                    <span class="member-count-label">{{ 'home.widgetInvite.membersLabel' | translate }}</span>
                </div>

                <div class="avatars">
                    <ng-container *ngFor="let user of selectedCommunity.members">
                        <app-user-avatar [firstName]="user.firstName" [lastName]="user.lastName" [picture]="user.pictureReference"></app-user-avatar>
                    </ng-container>
                    <button type="button" (click)="openModal()" class="btn btn-primary" title="Ajouter">
                        <i class="pi pi-plus"></i>
                    </button>

                    <p-dialog
                        [header]="'home.widgetInvite.dialogTitle' | translate"
                        [(visible)]="modalDisplay"
                        [modal]="true"
                        [draggable]="false"
                        [resizable]="false"
                        [dismissableMask]="true"
                        (onHide)="closeModal(false)"
                    >
                        <app-invite-member *ngIf="modalDisplay" [isModal]="true" (closeModalAndRefresh)="closeModal($event)"> </app-invite-member>
                    </p-dialog>
                </div>
            </div>
        </ng-container>
    </ng-container>

    <!-- SKELETON -->

    <ng-template #skeleton>
        <div class="title">
            <h3><p-skeleton width="8rem"></p-skeleton></h3>
        </div>

        <div class="invite-main">
            <div class="member-count-container">
                <span class="bold-info member-count"><p-skeleton height="2rem" width="6rem"></p-skeleton></span>
                <span class="member-count-label"><p-skeleton height="1rem" width="4rem"></p-skeleton></span>
            </div>

            <div class="avatars">
                <p-skeleton shape="circle" size="38px"></p-skeleton>
                <p-skeleton shape="circle" size="38px"></p-skeleton>
                <p-skeleton shape="circle" size="38px"></p-skeleton>
                <p-skeleton shape="circle" size="38px"></p-skeleton>
                <p-skeleton shape="circle" size="38px"></p-skeleton>

                <button type="button" class="btn btn-primary" title="Ajouter" disabled>
                    <i class="pi pi-plus"></i>
                </button>
            </div>
        </div>
    </ng-template>
</div>
